import { FunctionalApproval } from '@lendiodevs/lendio-js-utilities/dist/calculator/functional-approval';
import { Approval } from '@lendiodevs/lendio-js-utilities/dist/calculator/types/approval';

const AchMaxPaymentApprovalSample = {
  'id': 15851460,
  'name': null,
  'dealId': 5055617,
  'calculationType': 'maxPayment',
  'stability': 'hard',
  'termType': 'months',
  'expires': '2025-01-28 00:00:00',
  'position': 1,
  'netMinimum': 82,
  'pointsTradable': 0,
  'payoffAmount': 0,
  'withheldAmount': 0,
  'notes': '[ApprovalSeeder] This is a test approval',
  'offerLink': 'https://lendersite.example/offers/23138291',
  'hasVariablePayment': null,
  'isTest': 0,
  'publishedToBorrower': null,
  'publishedByLenderUserId': null,
  'created': '2025-01-27 13:43:47',
  'modified': '2025-01-27 13:43:47',
  'deleted': null,
  'options': [
    {
      'id': 158522482,
      'approvalId': 15851460,
      'term': 7,
      'paymentFrequency': 'daily',
      'lenderOptionId': null,
      'buyRate': 1.25,
      'variablePercentOfRevenue': null,
      'payments': '212.9170',
      'created': '2025-01-27 13:43:47',
      'modified': '2025-01-27 13:43:47',
      'deleted': null,
      'customCalculatorParams': null,
      'limits': {
        'amount': {
          'min': 0,
          'max': 44800
        },
        'points': {
          'min': 0,
          'max': 12
        },
        'originationPercent': {
          'min': 2.5,
          'max': 2.5
        },
        'originationAmount': {
          'min': 300,
          'max': 0
        },
        'paymentAmountMax': 299.4
      }
    }
  ],
  'loanProductName': 'ACH',
  'loanProductRoundingStrategy': 'halfEven',
  'loanProductLenderId': 789,
  'loanProductId': 353,
  'calculatorConfig': {
    'drawFeeAmount': 'DEFAULT',
    'disbursement': 'DEFAULT',
    'annualInterestRate': 'DEFAULT',
    'payback': 'DEFAULT',
    'totalInterest': 'DEFAULT',
    'totalCostOfCapital': 'DEFAULT',
    'apr': 'DEFAULT',
    'centsOnTheDollar': 'DEFAULT',
    'paymentSchedule': {
      'scheduleRowPaymentAmount': 'DEFAULT',
      'scheduleRowInterestAmount': 'DEFAULT',
      'scheduleRowPrincipalAmount': 'DEFAULT',
      'scheduleRowEndBalance': 'DEFAULT'
    },
    'buyRate': 'DEFAULT'
  },
  'benefits': [],
  'points': '0.00',
  'loanProductLender': 'Fora Financial',
  'loanProductType': 'traditional',
  'requestNames': {
    'nonConditional': [
      'Voided Check - voided check needed',
      'Driver\'s License - driver\'s license needed',
      'Valid Phone Number - Valid Phone Number',
      'Alternative Phone Number - Alternative Phone Number',
      'Use of funds',
      'Voided Check - Please upload a voided check from your business bank account.',
      'Driver’s License - Please upload a copy of your driver\'s license.',
      'Proof of Business Address (Recent Business Utility Bill, Current Business License, or Executed Business Lease)',
      'Bank Verification',
      'Tax Return - Business Tax Return document for specified year.'
    ],
    'conditional': []
  },
  'loanProductCategoryType': 'ach'
};

export const AchMaxPaymentFunctionalApprovalSample = new FunctionalApproval(AchMaxPaymentApprovalSample as unknown as Approval);
